import {
  FETCH_CONFLICT_COMPANIES_START,
  FETCH_CONFLICT_COMPANIES_SUCCESS,
  FETCH_CONFLICT_COMPANIES_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  conflict: {},
  isFetching: true,
  errorMessage: '',
}

const conflictCompaniesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONFLICT_COMPANIES_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_CONFLICT_COMPANIES_SUCCESS:
      return {
        ...state,
        conflict: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_CONFLICT_COMPANIES_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default conflictCompaniesReducer
